/**
 * Sidebar logo — renders the "VERINT" brand text and tagline.
 * Fully light/dark mode aware.
 */

import { makeStyles } from '@material-ui/core';
import { Link, sidebarConfig } from '@backstage/core-components';

const useStyles = makeStyles(theme => {
  const isDark = theme.palette.type === 'dark';
  return {
    root: {
      width: 240,
      height: 3.5 * sidebarConfig.logoHeight,
      display: 'flex',
      flexFlow: 'column nowrap',
      alignItems: 'flex-start',
      justifyContent: 'center',
      paddingLeft: 24,
      paddingRight: 24,
    },
    link: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column' as const,
      textDecoration: 'none !important' as any,
      padding: '8px 8px',
    },
    logo: {
      height: 32,
      width: 'auto',
      display: 'block',
    },
    tagline: {
      fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", "Segoe UI", Roboto, sans-serif',
      fontWeight: 500,
      fontSize: 14,
      color: isDark ? '#6e7479' : '#8c9196',
      letterSpacing: '0.01em',
      marginTop: 6,
      marginLeft: 4,
    },
  };
});

export const SidebarLogo = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Link to="/" underline="none" className={classes.link} aria-label="Home">
        <img src="/Verint-Logo-Blue.png" alt="Verint" className={classes.logo} />
        <span className={classes.tagline}>Developer Portal</span>
      </Link>
    </div>
  );
};
